import { render, staticRenderFns } from "./Profil.vue?vue&type=template&id=72ac4a8c&scoped=true&"
import script from "./Profil.js?vue&type=script&lang=js&"
export * from "./Profil.js?vue&type=script&lang=js&"
import style0 from "./Profil.scoped.scss?vue&type=style&index=0&id=72ac4a8c&lang=scss&scoped=true&"
import style1 from "./Profil.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ac4a8c",
  null
  
)

export default component.exports